import { Injectable } from '@angular/core';
import { FabricService } from '../fabric/fabric.service';
import { Observable } from 'rxjs';

const SERVICE_NAME = 'rag-status-resources';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {

  constructor(private fabricService: FabricService) { }

  getRagStatus(tenant): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_rag_status', {client_name: tenant});
  }
}
